/* kts-upcart-fix.js (05-oct-2026)
   El carrito lateral es la app Upcart (shadow DOM). Su configuración sale en español/inglés en
   todas las webs y no dice nada de envío, devolución ni preventa. Esto:
   1) traduce los 4 textos fijos al idioma de la página;
   2) inserta encima del botón de pago el mismo bloque que /cart (snippet kts-cart-garantias,
      pintado en Liquid con el país real del visitante) y muestra la línea de preventa solo
      si el carrito lleva un producto en preventa (propiedad _preventa o etiqueta).
   No toca precios, ni el checkout, ni la configuración de la app. */
(function(){
  var L=(document.documentElement.getAttribute('lang')||'en').slice(0,2).toLowerCase();
  var T={
    mas:{en:'You may also like',es:'Completa tu setup',de:'Passt dazu',fr:'Vous aimerez aussi',it:'Potrebbe interessarti'},
    save:{en:'Save',es:'Ahorras',de:'Du sparst',fr:'Économie',it:'Risparmi'},
    rev:{en:'reviews',es:'reseñas',de:'Bewertungen',fr:'avis',it:'recensioni'},
    pay:{en:'Checkout',es:'Pagar',de:'Zur Kasse',fr:'Paiement',it:'Vai al pagamento'},
    add:{en:'Add',es:'Añadir',de:'Hinzufügen',fr:'Ajouter',it:'Aggiungi'}
  };
  function t(k){return (T[k][L]||T[k].en);}
  var tpl=document.getElementById('kts-ucg-tpl');
  var hayPre=null;
  function compruebaPre(cb){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      hayPre=(c.items||[]).some(function(i){return i.properties&&i.properties._preventa;});
      cb&&cb();
    }).catch(function(){});
  }
  function arregla(sh){
    var all=sh.querySelectorAll('p,span,a,h3');
    for(var i=0;i<all.length;i++){
      var e=all[i]; if(e.children.length) continue;
      var s=e.textContent;
      if(/^\s*¿Necesitas más\?\s*$/.test(s)) e.textContent=t('mas');
      else if(/^\(Save\s/.test(s)) e.textContent=s.replace(/^\(Save\s/,'('+t('save')+' ');
      else if(/^\(\d+ reviews?\)$/.test(s)) e.textContent=s.replace(/reviews?/,t('rev'));
    }
    var inp=sh.querySelectorAll('input[type=submit],input[type=button]');
    for(var q=0;q<inp.length;q++){ if(/^\s*Add\s*$/.test(inp[q].value)) inp[q].value=t('add'); }
    var a=sh.querySelectorAll('a,button');
    for(var j=0;j<a.length;j++){
      var b=a[j]; if(b.children.length) continue;
      if(/^\s*Checkout\s*•/.test(b.textContent)) b.textContent=b.textContent.replace(/Checkout/,t('pay'));
      else if(/^\s*Add\s*$/.test(b.textContent)) b.textContent=t('add');
    }
    if(tpl && !sh.getElementById('kts-ucg')){
      var pago=null;
      for(var k=0;k<a.length;k++){ if(/•/.test(a[k].textContent)&&/\d/.test(a[k].textContent)){pago=a[k];break;} }
      if(pago){
        var box=document.createElement('div'); box.id='kts-ucg'; box.style.margin='0 0 10px';
        box.appendChild(tpl.content.cloneNode(true));
        var cont=pago.parentElement; cont.parentElement.insertBefore(box,cont);
      }
    }
    var pre=sh.querySelector('#kts-ucg .kts-cg__pre');
    if(pre) pre.style.display = hayPre ? '' : 'none';
  }
  var pend=null;
  function vigila(){
    var host=document.getElementById('upCart');
    if(!host||!host.shadowRoot){ return setTimeout(vigila,800); }
    var sh=host.shadowRoot;
    new MutationObserver(function(){
      if(pend) return;
      pend=setTimeout(function(){ pend=null; compruebaPre(function(){arregla(sh);}); arregla(sh); },120);
    }).observe(sh,{childList:true,subtree:true,characterData:true});
    compruebaPre(function(){arregla(sh);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',vigila); else vigila();
})();
